import type { SubItemTypeMetaMap } from './subItemTypeMeta';

export interface SubItemCategory {
  id: string;
  key: string;
  label: string;
  pricingMode: 'qty_rate' | 'amount';
  markupApplicable: boolean;
  taxApplicable: boolean;
  isBuiltIn: boolean;
  sortOrder: number;
}

export const BUILT_IN_KEYS = {
  LABOR: 'labor',
  PROFIT: 'profit',
  DISCOUNT: 'discount',
} as const;

export const DEFAULT_SUB_ITEM_CATEGORIES: Omit<SubItemCategory, 'id'>[] = [
  { key: 'labor', label: 'Labor', pricingMode: 'qty_rate', markupApplicable: true, taxApplicable: true, isBuiltIn: true, sortOrder: 0 },
  { key: 'electrical', label: 'Electrical', pricingMode: 'qty_rate', markupApplicable: true, taxApplicable: false, isBuiltIn: false, sortOrder: 1 },
  { key: 'plumbing', label: 'Plumbing', pricingMode: 'qty_rate', markupApplicable: true, taxApplicable: false, isBuiltIn: false, sortOrder: 2 },
  { key: 'materials', label: 'Materials', pricingMode: 'amount', markupApplicable: true, taxApplicable: false, isBuiltIn: false, sortOrder: 3 },
  { key: 'dumpFees', label: 'Dump Fees', pricingMode: 'amount', markupApplicable: true, taxApplicable: false, isBuiltIn: false, sortOrder: 4 },
  { key: 'misc', label: 'Misc.', pricingMode: 'amount', markupApplicable: true, taxApplicable: false, isBuiltIn: false, sortOrder: 5 },
  { key: 'profit', label: 'Profit', pricingMode: 'amount', markupApplicable: false, taxApplicable: false, isBuiltIn: true, sortOrder: 6 },
  { key: 'discount', label: 'Discount', pricingMode: 'amount', markupApplicable: false, taxApplicable: false, isBuiltIn: true, sortOrder: 7 },
];

export function isQtyRateCategory(key: string, typeMeta: SubItemTypeMetaMap): boolean {
  return typeMeta[key]?.pricingMode === 'qty_rate';
}

export function getSubItemLabel(key: string, typeMeta: SubItemTypeMetaMap): string {
  return typeMeta[key]?.label ?? key;
}

export function slugify(label: string): string {
  return label
    .trim()
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/\s+(.)/g, (_, c) => c.toUpperCase())
    .replace(/^\w/, (c) => c.toLowerCase());
}
